<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="customerPriceList.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="230"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="customerPriceList"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :customer-price-list="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="customerPriceList.per_page"
        layout="total, prev, pager, next"
        :total="customerPriceList.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'asc',
        },
      };
    },
    computed: {
      customerPriceList() {
        return this.$store.getters['customerPriceList/customerPriceLists'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['customerPriceList/tableConfig']));
      },
      loading() {
        return this.$store.getters['customerPriceList/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('customerPriceList/setFilterString', '');
      this.$store.commit('customerPriceList/setCurrentPage', this.currentPage);
      this.$store.commit('customerPriceList/setSorting', this.currentSort);
      await this.$store.dispatch('customerPriceList/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('customerPriceList/setCurrentPage', val);
        this.$store.dispatch('customerPriceList/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('customerPriceList/setSorting', { prop, order });
          this.$store.dispatch('customerPriceList/fetchAll');
        }
      },
    },
  };
</script>



